<template>
  <div class="active-schools">
    <h1 class="text-center my-7">ویرایش پورتال</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-card class="elevation-0 mb-5 pa-5">
          <h4>ویرایش پورتال {{ name }}</h4>
          <v-alert v-if="alert" small outlined type="success" class="my-4">
            {{ alert }}
          </v-alert>
          <v-form
            v-model="valid"
            @submit.prevent="editPortal"
            class="text-center mt-3"
          >
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  autocomplete="off"
                  label="نام پورتال"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="url"
                  :rules="urlRules"
                  autocomplete="off"
                  hint="فقط ساب دامین را بدون بدون www و http یا https وارد کنید"
                  label="ساب دامین پورتال"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="title"
                  :rules="titleRules"
                  autocomplete="off"
                  label="نام صفحه اصلی"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="address"
                  :rules="addressRules"
                  autocomplete="off"
                  hint="آدرس مدرسه را به همراه استان و شهرستان تایپ نمایید"
                  label="آدرس مدرسه"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="tel"
                  :rules="telRules"
                  autocomplete="off"
                  hint="شماره تلفن را بدون خط تیره و همراه با کد شهر وارد نمایید"
                  label="تلفن تماس مدرسه"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="description"
                  :rules="descriptionRules"
                  autocomplete="off"
                  label="توضیحات"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  id="pEndDate"
                  label="تاریخ پایان"
                  v-model="pEndDate"
                  :rules="pEndDateRules"
                  hide-details="auto"
                />
                <date-picker
                  v-model="pEndDate"
                  :rules="pEndDateRules"
                  :auto-submit="true"
                  format="jYYYY/jMM/jDD"
                  element="pEndDate"
                  alt-name="endDate"
                  alt-format="YYYY-MM-DD HH:mm:ss"
                />
              </v-col>
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  depressed
                  block
                  color="primary"
                  type="submit"
                >
                  ارسال درخواست
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <v-btn
          outlined
          depressed
          block
          color="error"
          router
          :to="{ name: 'Portals' }"
          >بیخیال</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "../_Navigation.vue";
export default {
  name: "edit-portal-component",
  components: {
    Navigation
  },
  data: () => {
    return {
      valid: true,
      loading: false,
      alert: null,
      name: "",
      nameRules: [(v) => !!v || "وارد کردن نام پورتال اجباری است"],
      title: "",
      titleRules: [(v) => !!v || "وارد کردن نام صفحه اصلی پورتال اجباری است"],
      description: "",
      descriptionRules: [
        (v) => !!v || "وارد کردن توضیحات برای پورتال اجباری است"
      ],
      url: "",
      urlRules: [(v) => !!v || "وارد کردن آدرس پورتال اجباری است"],
      pEndDate: "",
      pEndDateRules: [
        (v) => !!v || "وارد کردن تاریخ پایان برای پورتال اجباری است"
      ],
      address: "",
      addressRules: [(v) => !!v || "وارد کردن آدرس پورتال اجباری است"],
      tel: "",
      telRules: [(v) => !!v || "وارد کردن آدرس پورتال اجباری است"]
    };
  },
  created() {
    this.getPortal();
  },
  methods: {
    getPortal() {
      this.loading = true;
      const apiUrl = "portal/" + this.$route.params.id;
      this.$api
        .get(apiUrl)
        .then((res) => {
          const data = res.data.portal;

          // set data
          this.name = data.name;
          this.title = data.title;
          this.description = data.description;
          this.address = data.address;
          this.tel = data.tel;
          this.pEndDate = this.$moment(data.endDate, "YYYY/MM/DD")
            .locale("fa")
            .format("YYYY/MM/DD");

          // fix url subdomain
          var domain = data.url.split(".")[1] ? data.url.split(".")[0] : "";
          domain = domain.replace(/(^\w+:|^)\/\//, "");
          this.url = domain;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editPortal() {
      this.loading = true;
      const endDate = document.getElementsByName("endDate")[0].value;
      this.$api
        .patch("/portal/update", {
          _id: this.$route.params.id,
          name: this.name,
          title: this.title,
          description: this.description,
          address: this.address,
          tel: this.tel,
          url: "https://" + this.url + ".pirls.ir",
          endDate: endDate
        })
        .then(() => {
          this.$router.push({ name: "Portals" });
        });
    }
  }
};
</script>
